<template>
    <ContainerContent
        class="mb-16"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Team Onboarding</h1>
            </v-col>
        </v-row>

        <p
            v-if="!submitSuccess"
            class="text-body-1"
        >
            Thank you for your interest in StringKing’s team program. Please fill out your team’s information below for review. Please be aware that eligibility depends on various factors, including proximity to our retail partners. While we strive to accommodate all inquiries, certain restrictions may apply. If we are unable to service your team directly, we will happily refer you to one of our retail partners in your area.
        </p>

        <OrgsRetailersTeamsForm
            class="mt-2"
            :flat="true"
            fields-format="teams"
            @on-success="onSuccess"
        ></OrgsRetailersTeamsForm>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import OrgsRetailersTeamsForm from '~/components/onboarding/OrgsRetailersTeamsForm/OrgsRetailersTeamsForm.vue';
    import { useGoTo } from 'vuetify';

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Teams Onboarding | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Teams Onboarding.'
            }
        ]
    });

    const goTo = useGoTo();
    const submitSuccess = ref(false);

    function onSuccess() {
        goTo(0);
        submitSuccess.value = true;
    }
</script>
